import React from "react";
import { Table } from "react-bootstrap";

import "../styles/util.css";

function ListJurisdiccion({ data }) {

  return (
    <>
      <h1 className="mt-3 mb-3">Distribución</h1>
      <Table>
        <thead>
          <tr className="bg-blue txt-white">
            <th className="">Jurisdicción</th>
            <th className="txt-center">Coeficiente</th>
          </tr>
        </thead>
        <tbody>
          {data.padronCtribJur.map((jur, i) => {
            return (
              <tr key={i}>
                <td className="txt-grey size-10">
                  {jur.idJurisdiccion + " - " + jur.descJurisdiccion}
                </td>
                <td className="txt-center size-10 txt-grey">{jur.coeficienteRecalc}</td>                
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}

export default ListJurisdiccion;
